import React from "react";
import { connect } from "react-redux";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import InnerLink from './InnerLink';
import { FormattedDate } from "react-intl";
import * as agent from "../agent";
import Preloader from './Preloader';
import MaterialDatePicker from './MaterialDatePicker';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import TablePaginationActions from "./TablePaginationActions";

class Log extends React.Component {
    state = {
        logsLoaded: false,
        logs: [],
        openedLogs: [],
        currentPage: 0,
        totalLogs: 0,
        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        endDate: new Date(),
        searchQuery: ""
    };

    componentDidMount () {
        this.fetchData();
    }

    fetchData = () => {
        this.setState({ logsLoaded: false })
        const { currentPage, searchQuery, startDate, endDate } = this.state;
        let criteria = Object.assign(
            { currentPage },
            startDate ? { startDate: startDate.valueOf() } : {},
            endDate ? { endDate: endDate.valueOf() } : {},
            searchQuery.length > 1 ? { searchQuery } : {}
        );
        agent.Log.all(criteria)
            .then(res => this.setState({
                logs: res.logs,
                totalLogs: res.count,
                logsLoaded: true
            }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }
    onStartDateChange = date => {
        this.setState({ startDate: new Date(date) }, () => this.fetchData());
    }
    onEndDateChange = date => {
        this.setState({ endDate: new Date(date) }, () => this.fetchData());
    }
    searchLogs = e => {
        const query = e.target.value;
        if(query.length < 2) return;
        this.setState({ searchQuery: query }, () => this.fetchData());
    }
    turnPage = (e, p) => {
        this.setState({ currentPage: p }, () => this.fetchData());
    }
    toggleAccordeon = (e, id) => {
        if (e.target.tagName === "A") return;
        const { openedLogs } = this.state;
        this.setState({ openedLogs: openedLogs.includes(id) ? openedLogs.filter(a => a !== id) : openedLogs.concat(id) });
    }

    render() {
        const { logsLoaded, totalLogs, openedLogs, currentPage, startDate, endDate, logs } = this.state;
        return (
            <Fade in={true}>
                <React.Fragment>
                    <Grid container justify="center">
                        <Grid item>
                            <Grid container justify="flex-start" spacing={8}>
                                <Grid item>
                                    <MaterialDatePicker label="Начало периода" value={startDate} onChange={this.onStartDateChange} />
                                </Grid>
                                <Grid item>
                                    <MaterialDatePicker label="Конец периода" value={endDate} onChange={this.onEndDateChange} />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs>
                        </Grid>
                        <Grid item style={{ width: 250 }}>
                            <TextField label="Поиск"
                                       helperText="Введите фамилию сотрудника"
                                       fullWidth
                                       InputLabelProps={{ shrink: true }}
                                       FormHelperTextProps={{ classes: {root: "input-error"} }}
                                       onChange={this.searchLogs}
                                       variant="outlined"
                                       padding="dense"
                                       margin="dense" />
                        </Grid>
                    </Grid>
                    {logsLoaded ?
                        <Fade in={logsLoaded}>
                            <Table padding="dense" className="m20">
                                <TableHead >
                                    <TableRow >
                                        <TableCell>Дата</TableCell>
                                        <TableCell>Сотрудник</TableCell>
                                        <TableCell>Всего операций</TableCell>
                                        <TableCell>IP-адрес</TableCell>
                                    </TableRow >
                                </TableHead >
                                <TableBody >
                                    {logs.map(({ _id, date, user = {}, requests = [], totalRequests, ip}, i) => (
                                        <React.Fragment key={i}>
                                            <TableRow onClick={e => this.toggleAccordeon(e, _id)}>
                                                <TableCell >
                                                    <FormattedDate value={date}
                                                                   day="numeric"
                                                                   month="numeric"
                                                                   year="numeric" />
                                                </TableCell>
                                                <TableCell>
                                                    <InnerLink target="_blank" href={`/user/${user._id}`} label={user.fullname} />
                                                </TableCell>
                                                <TableCell>
                                                    { totalRequests }
                                                </TableCell>
                                                <TableCell>
                                                    { ip }
                                                </TableCell>
                                            </TableRow >
                                            {openedLogs.includes(_id) &&
                                                <Fade in={openedLogs.includes(_id)}>
                                                    <TableRow >
                                                        <TableCell colSpan={16}>
                                                            {Object.keys(requests).map((f, j) =>
                                                                (<Typography key={j}>{`${f}: ${requests[f]}`}</Typography>)
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                </Fade>
                                            }
                                        </React.Fragment>)
                                    )}
                                </TableBody >
                                <TableFooter>
                                    <TableRow>
                                        <TableCell colSpan={20}>
                                            <Grid container justify="center">
                                                <TablePagination count={totalLogs}
                                                                 labelDisplayedRows={({ from, to, count }) => `${from}-${to} из ${count}`}
                                                                 rowsPerPage={20}
                                                                 rowsPerPageOptions={[]}
                                                                 page={currentPage}
                                                                 onChangePage={this.turnPage}
                                                                 ActionsComponent={TablePaginationActions} />
                                             </Grid>
                                         </TableCell>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </Fade> : <Preloader />}
                </React.Fragment>
            </Fade>
        );
    }
}

export default connect(null,null)(Log);



// WEBPACK FOOTER //
// ./src/components/Log.js